import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-settings.action';
import {LoadEcommerceSettings} from '../actions/ecommerce-settings.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommerceSettingsService} from "../../websites/website/ecommerce/ecommerce-settings/ecommerce-settings.service";

@Injectable()
export class EcommerceSettingsEffect {

  loadEcommerceSettings$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_SETTINGS),
    mergeMap((action: LoadEcommerceSettings) => {
      const {websiteId} = action.payload;
      return this._settingsService.getSettings(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceSettingsSuccess({
                settings: response.data,
                websiteId
              });
            }
            return new EcommerceActions.LoadEcommerceSettingsFail({websiteId});
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _settingsService: EcommerceSettingsService,
  ) {
  }

}
